var exports = {
  "k": "container__R0kThY",
};

module.exports = exports;
